export type Candidate = {
  name: string;
  styles: {
    default: string;
    hover: string;
    selected: string;
  }
}

export enum QuestionType {
  Question,
  Topic
}

export type Message = {
  speaker: string;
  content: string;
}